import { CircularProgress } from "@mui/material"
import { IRootState } from "app/model"
import { INVENTORY_MAP_VIEW_TYPES } from "form/inventory/model"
import { getInventory } from "form/inventory/tools/common"
import React from "react"
import { connect } from "react-redux"

interface IInventoryMapLoaderProps {
  isMapRefreshing: boolean
  mapType: INVENTORY_MAP_VIEW_TYPES
}

const InventoryMapLoaderFn = React.memo(({ isMapRefreshing, mapType }: IInventoryMapLoaderProps) => {
  if (!isMapRefreshing || mapType === INVENTORY_MAP_VIEW_TYPES.GEO_TARGETS) {
    return null
  }
  return <CircularProgress sx={{ position: "absolute" }} />
})

export const InventoryMapLoader = connect((state: IRootState): IInventoryMapLoaderProps => {
  const inventory = getInventory(state)
  return {
    isMapRefreshing: inventory.isMapRefreshing,
    mapType: inventory.mapViewType
  }
})(InventoryMapLoaderFn)
